var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5857 3.33154C15.9096 3.33154 17.5715 3.33154 18.6041 4.42868C19.6367 5.52582 19.6367 7.29163 19.6367 10.8233C19.6367 14.3549 19.6367 16.1207 18.6041 17.2178C17.5715 18.315 15.9096 18.315 12.5857 18.315L9.06018 18.315C5.73629 18.315 4.07435 18.315 3.04175 17.2178C2.00915 16.1207 2.00915 14.3549 2.00915 10.8233C2.00915 7.29163 2.00915 5.52582 3.04175 4.42868C4.07435 3.33154 5.73629 3.33154 9.06018 3.33154L12.5857 3.33154Z",
    stroke: "white",
    strokeWidth: 1.45978,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65332 13.9081C6.07115 12.0243 9.37214 11.9214 10.823 13.9081M9.2797 9.28094C9.2797 10.1328 8.58913 10.8233 7.73728 10.8233C6.88543 10.8233 6.19487 10.1328 6.19487 9.28094C6.19487 8.42909 6.88543 7.73853 7.73728 7.73853C8.58913 7.73853 9.2797 8.42909 9.2797 9.28094Z",
    stroke: "white",
    strokeWidth: 1.45978,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4668 8.61963L16.9923 8.61963",
    stroke: "white",
    strokeWidth: 1.45978,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4668 12.1453H15.2296",
    stroke: "white",
    strokeWidth: 1.45978,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCard);
export default __webpack_public_path__ + "static/media/student-card.338415e815205bf5945be666991327fd.svg";
export { ForwardRef as ReactComponent };